import { render } from "./MenuCompselector.vue?vue&type=template&id=295ba543&scoped=true"
import script from "./MenuCompselector.vue?vue&type=script&lang=js"
export * from "./MenuCompselector.vue?vue&type=script&lang=js"

import "./MenuCompselector.vue?vue&type=style&index=0&id=295ba543&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295ba543"]])

export default __exports__